/* eslint-disable class-methods-use-this */
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import { castDateToLocalTimezone } from '@packages/toolbox/dist/utils/datetime';
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import {
  BASE_USER_PROFILE_URL,
  USER_PROFILE_ENDPOINTS,
} from 'SharedDir/backend/endpoints/user-profiles';
import { StatusResponse } from 'SharedDir/declarations/endpoint';
import { FieldValueHistoryRecord } from 'SharedDir/declarations/fields';
import { Nullable, Optional, WithRelations } from 'SharedDir/declarations/shared';
import { UserProfileBare, UserProfile } from 'SharedDir/declarations/user-profiles';

export default class UserProfileApiClass extends SimpleApi<
  UserProfile,
  UserProfileBare,
  UserProfileBare,
  UserProfileBare
> {
  constructor() {
    super(BASE_USER_PROFILE_URL);
  }

  /**
   * Получаем все профили пользователя
   *
   * @param {number} userId
   * @returns {Promise<Array<Required<UserProfile>>>}
   * @memberof UserProfileApi
   */
  async getForUser(userId: number) {
    const { data } = await this.getPaginated({
      userId,
      sortBy: 'name',
      rowsPerPage: null,
      page: 1,
      descending: false,
    });

    return data;
  }

  /**
   * Активация профиля пользователя (consumer)
   * @param id
   */
  async activate(id: number): Promise<StatusResponse> {
    const { data } = await http({
      ...USER_PROFILE_ENDPOINTS.ACTIVATE(id),
    });

    return data;
  }

  /**
   * Деактивация профиля пользователя (consumer)
   *
   * @param id
   */
  async deactivate(id: number): Promise<StatusResponse> {
    const { data } = await http({
      ...USER_PROFILE_ENDPOINTS.DEACTIVATE(id),
    });

    return data;
  }

  /**
   * Календарь мероприятий пользователя
   *
   * @param id
   */
  async calendar(id: number): Promise<StatusResponse> {
    const { data } = await http({
      ...USER_PROFILE_ENDPOINTS.CALENDAR(id),
    });

    return data;
  }
}
